import * as React from 'react';
import { FC } from 'react';
import { IMedia } from '../../../../../types';
import { style } from 'typestyle';

interface ImageDisplayProps {
  post: IMedia;
}

const ImageDisplay: FC<ImageDisplayProps> = ({ post }) => {
  return (
    <img 
      src={post.image} 
      alt={post.caption || 'Post image'} 
      className={styles.media} 
    />
  );
};

export default ImageDisplay;

const styles = {  media: style({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}),}